import {ToastActions} from "../constants/toastActions";

const INITIAL_STATE = {

    title: '',
    show: false,
    openSide : false
};
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ToastActions.SHOW:

            return { ...state, title: action.payload.title, show: true  };
       case ToastActions.SHOWSIDEBAR:

            return { ...state,  openSide: action.payload.openSide  };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/toast.ts